import React from 'react';
import { stringUtils } from '~/util';
import { SORT_ORDER } from './util';
import { useGrid } from './state';
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';

const HeaderCell = ({ column }) => {
    const { state, dispatch } = useGrid();

    const { sort } = state;

    const isSortColumn = stringUtils.hasValue(sort.column)
        && sort.column == column.key;

    const currentOrder = isSortColumn
        ? sort.order
        : SORT_ORDER.NONE;

    let sortable = column?.title?.length > 0
        || typeof column?.sorter == 'function';

    if (column?.canSort != undefined)
        sortable = column.canSort;

    let style = {};

    if (column.width) 
        style = { width: column.width };

    if (sortable)
        style.cursor = 'pointer';

    return typeof column.title == 'function' 
        ? column.title() 
        : (
            <th
                style={style}
                className={column.headerClassName}
                onClick={() => {
                    const order = getNextSortOrder(currentOrder);
                    dispatch.setSort({ column: column.key, order });
                }}
            >
                <span className='flex items-center'>
                    {column.title}
                    {sortable && (
                        <SortIndicator 
                            currentOrder={currentOrder}
                            className='ml-auto'
                            size='1em'
                        />
                    )}
                </span>
            </th>
        );
};

export default HeaderCell;

function SortIndicator({ currentOrder, ...rest }) {
    if (currentOrder == SORT_ORDER.ASC) {
        return <FaSortUp {...rest} />;
    }
    if (currentOrder == SORT_ORDER.DESC) {
        return <FaSortDown {...rest} />;
    }

    return <FaSort {...rest} />;
}

function getNextSortOrder(currentOrder) {
    const sortOrders = new Map([
        [SORT_ORDER.NONE, SORT_ORDER.ASC],
        [SORT_ORDER.ASC, SORT_ORDER.DESC],
        [SORT_ORDER.DESC, SORT_ORDER.NONE]
    ]);
    
    return sortOrders.has(currentOrder)
        ? sortOrders.get(currentOrder)
        : SORT_ORDER.NONE;
}